import styled from 'styled-components';

export default styled.div`
  padding: 2em;
  max-width: 1200px;
  margin: 0 auto;

  .settings--header {
    margin-bottom: 2em;

    h1 {
      font-size: 2rem;
      color: #fff;
      margin-bottom: 0.25em;
    }

    p {
      color: rgba(255, 255, 255, 0.6);
      font-size: 1rem;
    }
  }

  .tabs--navigation {
    display: flex;
    gap: 0.5em;
    margin-bottom: 2em;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    overflow-x: auto;

    @media (max-width: 768px) {
      gap: 0.25em;
    }

    .tab--button {
      display: flex;
      align-items: center;
      gap: 0.5em;
      padding: 1em 1.5em;
      background: transparent;
      border: none;
      border-bottom: 3px solid transparent;
      color: rgba(255, 255, 255, 0.6);
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;

      @media (max-width: 768px) {
        padding: 0.875em 1em;
        font-size: 0.9rem;
      }

      svg {
        font-size: 1.2rem;
      }

      &:hover {
        color: rgba(255, 255, 255, 0.9);
        background: rgba(255, 255, 255, 0.05);
      }

      &.active {
        color: ${({ theme }) => theme.primary};
        border-bottom-color: ${({ theme }) => theme.primary};
        background: rgba(254, 125, 17, 0.1);
      }
    }
  }

  .settings--content {
    display: flex;
    flex-direction: column;
    gap: 2em;
  }

  .settings--section {
    background: #1a1d35;
    border-radius: 12px;
    padding: 2em;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

    .section--header {
      display: flex;
      align-items: center;
      gap: 0.75em;
      margin-bottom: 1.5em;

      .icon {
        font-size: 1.5rem;
        color: ${({ theme }) => theme.primary};
      }

      h2 {
        font-size: 1.5rem;
        color: #fff;
        margin: 0;
      }
    }

    .section--description {
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 1.5em;
      line-height: 1.6;
    }
  }

  .settings--form {
    .form--grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1.5em;
      margin-bottom: 1.5em;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }

      .full-width {
        grid-column: 1 / -1;
      }
    }

    .form--group {
      label {
        display: block;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 600;
        margin-bottom: 0.5em;
        font-size: 0.9rem;
      }

      input,
      textarea {
        width: 100%;
        padding: 0.875em 1em;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        color: #fff;
        font-size: 1rem;
        transition: all 0.3s ease;
        font-family: inherit;

        &::placeholder {
          color: rgba(255, 255, 255, 0.4);
        }

        &:focus {
          outline: none;
          border-color: ${({ theme }) => theme.primary};
          background: rgba(255, 255, 255, 0.08);
        }
      }

      textarea {
        resize: vertical;
        min-height: 100px;
      }
    }

    .password--input {
      position: relative;

      input {
        padding-right: 3em;
      }

      .toggle--visibility {
        position: absolute;
        right: 0.75em;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        color: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        font-size: 1.1rem;
        padding: 0.5em;
        transition: color 0.3s ease;

        &:hover {
          color: ${({ theme }) => theme.primary};
        }
      }
    }

    .message {
      padding: 1em 1.25em;
      border-radius: 8px;
      margin-bottom: 1em;
      font-size: 0.95rem;

      &.success {
        background: rgba(76, 175, 80, 0.15);
        color: #81C784;
        border: 1px solid rgba(76, 175, 80, 0.3);
      }

      &.error {
        background: rgba(244, 67, 54, 0.15);
        color: #E57373;
        border: 1px solid rgba(244, 67, 54, 0.3);
      }
    }
  }

  .notification--options {
    display: flex;
    flex-direction: column;
    gap: 1.5em;

    .notification--item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.25em;
      background: rgba(255, 255, 255, 0.03);
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.05);

      .notification--info {
        strong {
          display: block;
          color: #fff;
          font-size: 1rem;
          margin-bottom: 0.25em;
        }

        p {
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.875rem;
          margin: 0;
        }
      }
    }
  }

  .toggle {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;

    input {
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + .slider {
        background: ${({ theme }) => theme.primary};

        &:before {
          transform: translateX(24px);
        }
      }

      &:focus + .slider {
        box-shadow: 0 0 1px ${({ theme }) => theme.primary};
      }
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.2);
      transition: 0.4s;
      border-radius: 34px;

      &:before {
        position: absolute;
        content: "";
        height: 18px;
        width: 18px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        transition: 0.4s;
        border-radius: 50%;
      }
    }
  }

  .documentation--card {
    background: linear-gradient(135deg, rgba(254, 125, 17, 0.1) 0%, rgba(254, 125, 17, 0.05) 100%);
    border: 2px solid rgba(254, 125, 17, 0.3);
    border-radius: 12px;
    padding: 2em;
    display: flex;
    gap: 2em;
    align-items: flex-start;
    margin-top: 1.5em;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 1.5em;
      gap: 1.5em;
    }

    .doc--card--icon {
      font-size: 4rem;
      flex-shrink: 0;

      @media (max-width: 768px) {
        font-size: 3rem;
      }
    }

    .doc--card--content {
      flex: 1;

      h3 {
        color: #fff;
        font-size: 1.5rem;
        margin-bottom: 0.75em;

        @media (max-width: 768px) {
          font-size: 1.25rem;
        }
      }

      p {
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.6;
        margin-bottom: 1em;
      }

      .doc--features {
        list-style: none;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5em;

        @media (max-width: 768px) {
          grid-template-columns: 1fr;
        }

        li {
          color: rgba(255, 255, 255, 0.9);
          font-size: 0.95rem;
          padding: 0.5em 0;
        }
      }
    }

    .doc--card--actions {
      display: flex;
      flex-direction: column;
      gap: 0.75em;
      flex-shrink: 0;

      @media (max-width: 768px) {
        width: 100%;
      }

      .btn {
        white-space: nowrap;
        text-decoration: none;
        text-align: center;

        @media (max-width: 768px) {
          width: 100%;
        }
      }

      .btn--secondary {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: #fff;

        &:hover:not(:disabled) {
          background: rgba(255, 255, 255, 0.15);
        }
      }
    }
  }

  .api--key--generator {
    display: flex;
    gap: 1em;
    margin-bottom: 2em;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    .api--key--input {
      flex: 1;
      padding: 0.875em 1em;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      color: #fff;
      font-size: 1rem;

      &::placeholder {
        color: rgba(255, 255, 255, 0.4);
      }

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primary};
        background: rgba(255, 255, 255, 0.08);
      }
    }

    .btn--generate {
      display: flex;
      align-items: center;
      gap: 0.5em;
      padding: 0.875em 1.5em;
      background: ${({ theme }) => theme.primary};
      border: none;
      border-radius: 8px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(254, 125, 17, 0.4);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
      }
    }
  }

  .api--keys--list {
    display: flex;
    flex-direction: column;
    gap: 1em;

    .empty--state {
      text-align: center;
      padding: 3em 2em;
      color: rgba(255, 255, 255, 0.5);

      .empty--icon {
        font-size: 3rem;
        margin-bottom: 1em;
        opacity: 0.3;
      }

      p {
        margin: 0;
      }
    }

    .api--key--item {
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      padding: 1.5em;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 1em;

      @media (max-width: 768px) {
        flex-direction: column;
        padding: 1em;
      }

      .api--key--info {
        flex: 1;
        min-width: 0; /* Allow flex item to shrink */

        .api--key--header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.75em;
          flex-wrap: wrap;
          gap: 0.5em;

          strong {
            color: #fff;
            font-size: 1.1rem;
            word-break: break-word;

            @media (max-width: 768px) {
              font-size: 1rem;
            }
          }

          .api--key--status {
            padding: 0.25em 0.75em;
            border-radius: 12px;
            font-size: 0.75rem;
            font-weight: 600;

            &.active {
              background: rgba(76, 175, 80, 0.2);
              color: #81C784;
            }
          }
        }

        .api--key--value {
          display: flex;
          align-items: center;
          gap: 0.75em;
          padding: 0.75em 1em;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 6px;
          margin-bottom: 0.75em;
          min-width: 0; /* Allow flex item to shrink */

          @media (max-width: 768px) {
            padding: 0.5em 0.75em;
            gap: 0.5em;
          }

          code {
            flex: 1;
            color: ${({ theme }) => theme.primary};
            font-family: 'Courier New', monospace;
            font-size: 0.9rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            min-width: 0; /* Allow code to shrink */

            @media (max-width: 768px) {
              font-size: 0.75rem;
            }
          }

          .api--key--actions {
            display: flex;
            gap: 0.5em;
            flex-shrink: 0; /* Prevent buttons from shrinking */

            @media (max-width: 768px) {
              gap: 0.25em;
            }

            .btn--icon {
              background: rgba(255, 255, 255, 0.1);
              border: none;
              padding: 0.5em;
              border-radius: 4px;
              color: rgba(255, 255, 255, 0.7);
              cursor: pointer;
              transition: all 0.2s ease;
              display: flex;
              align-items: center;
              justify-content: center;

              @media (max-width: 768px) {
                padding: 0.4em;
                font-size: 0.9rem;
              }

              &:hover {
                background: rgba(255, 255, 255, 0.15);
                color: ${({ theme }) => theme.primary};
              }
            }
          }
        }

        .api--key--meta {
          display: flex;
          gap: 1.5em;
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.5);
          flex-wrap: wrap;

          @media (max-width: 768px) {
            font-size: 0.75rem;
            gap: 1em;
          }

          span {
            white-space: nowrap;
          }
        }
      }

      .btn--delete {
        padding: 0.625em 1.25em;
        background: rgba(244, 67, 54, 0.15);
        border: 1px solid rgba(244, 67, 54, 0.3);
        border-radius: 6px;
        color: #E57373;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        flex-shrink: 0;

        @media (max-width: 768px) {
          width: 100%;
          padding: 0.75em 1em;
        }

        &:hover {
          background: rgba(244, 67, 54, 0.25);
        }
      }
    }
  }

  .btn {
    padding: 0.875em 2em;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &--primary {
      background: ${({ theme }) => theme.primary};
      color: #fff;

      &:hover:not(:disabled) {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(254, 125, 17, 0.4);
      }
    }
  }

  @media (max-width: 768px) {
    padding: 1em;

    .settings--header {
      h1 {
        font-size: 1.5rem;
      }
    }

    .settings--section {
      padding: 1.5em;

      .section--header {
        h2 {
          font-size: 1.25rem;
        }
      }
    }
  }

  /* Webhooks Styles */
  .webhooks--header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2em;
    gap: 2em;

    @media (max-width: 968px) {
      flex-direction: column;
      gap: 1.5em;
    }

    .webhooks--title--section {
      display: flex;
      gap: 1em;
      flex: 1;

      .icon {
        font-size: 2rem;
        color: ${({ theme }) => theme.primary};
        flex-shrink: 0;
      }

      h2 {
        font-size: 1.5rem;
        color: #fff;
        margin: 0 0 0.5em 0;
      }

      p {
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.6;
        margin: 0;
      }
    }

    .btn--add--webhook {
      display: flex;
      align-items: center;
      gap: 0.5em;
      padding: 0.875em 1.5em;
      background: ${({ theme }) => theme.primary};
      border: none;
      border-radius: 8px;
      color: #fff;
      font-weight: 600;
      font-size: 1rem;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;
      flex-shrink: 0;

      span {
        font-size: 1.25rem;
      }

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(254, 125, 17, 0.4);
      }

      @media (max-width: 968px) {
        width: 100%;
        justify-content: center;
      }
    }
  }

  .webhooks--container {
    display: grid;
    grid-template-columns: 350px 1fr;
    gap: 2em;
    min-height: 500px;

    @media (max-width: 1200px) {
      grid-template-columns: 300px 1fr;
    }

    @media (max-width: 968px) {
      grid-template-columns: 1fr;
    }
  }

  .webhooks--sidebar {
    background: #1a1d35;
    border-radius: 12px;
    padding: 1.5em;
    display: flex;
    flex-direction: column;
    gap: 1em;
    height: fit-content;

    .sidebar--header {
      h3 {
        font-size: 1.125rem;
        color: #fff;
        margin: 0;
      }
    }

    .empty--state--sidebar {
      text-align: center;
      padding: 3em 1em;
      color: rgba(255, 255, 255, 0.4);

      svg {
        font-size: 2.5rem;
        margin-bottom: 0.5em;
        opacity: 0.3;
      }

      p {
        margin: 0;
        font-size: 0.9rem;
      }
    }

    .webhook--list--sidebar {
      display: flex;
      flex-direction: column;
      gap: 0.75em;
    }

    .webhook--card {
      display: flex;
      align-items: center;
      gap: 1em;
      padding: 1em;
      background: rgba(255, 255, 255, 0.03);
      border: 2px solid rgba(255, 255, 255, 0.05);
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(254, 125, 17, 0.3);
      }

      &.active {
        background: rgba(254, 125, 17, 0.15);
        border-color: ${({ theme }) => theme.primary};
      }

      .webhook--card--icon {
        width: 40px;
        height: 40px;
        background: rgba(254, 125, 17, 0.2);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({ theme }) => theme.primary};
        font-size: 1.25rem;
        flex-shrink: 0;
      }

      .webhook--card--content {
        flex: 1;
        min-width: 0;

        .webhook--card--header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.5em;
          gap: 0.5em;

          strong {
            color: #fff;
            font-size: 0.95rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .status--badge {
            padding: 0.25em 0.65em;
            border-radius: 12px;
            font-size: 0.7rem;
            font-weight: 600;
            flex-shrink: 0;

            &.active {
              background: rgba(76, 175, 80, 0.2);
              color: #81C784;
            }

            &.inactive {
              background: rgba(158, 158, 158, 0.2);
              color: #BDBDBD;
            }
          }
        }

        .webhook--card--url {
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.8rem;
          font-family: 'Courier New', monospace;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0.5em;
        }

        .webhook--card--meta {
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.8rem;
        }
      }

      .webhook--card--arrow {
        background: none;
        border: none;
        color: rgba(255, 255, 255, 0.3);
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        flex-shrink: 0;
      }
    }

    .view--logs--btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5em;
      padding: 0.875em 1em;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      color: rgba(255, 255, 255, 0.8);
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      margin-top: auto;

      &:hover {
        background: rgba(255, 255, 255, 0.08);
        color: ${({ theme }) => theme.primary};
      }
    }
  }

  .webhooks--main {
    background: #1a1d35;
    border-radius: 12px;
    padding: 2em;
    min-height: 500px;

    .empty--state--main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      min-height: 400px;
      color: rgba(255, 255, 255, 0.5);

      .empty--icon {
        font-size: 4rem;
        margin-bottom: 1em;
        opacity: 0.3;
      }

      h3 {
        color: #fff;
        margin: 0 0 0.5em 0;
      }

      p {
        margin: 0;
        opacity: 0.7;
      }
    }
  }

  .webhook--form--wrapper,
  .webhook--details--wrapper {
    .webhook--form--header,
    .webhook--details--header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding-bottom: 1.5em;
      margin-bottom: 1.5em;
      border-bottom: 2px solid rgba(255, 255, 255, 0.1);
      gap: 1em;

      h3 {
        color: #fff;
        font-size: 1.5rem;
        margin: 0 0 0.5em 0;
      }

      .status--badge {
        padding: 0.35em 0.85em;
        border-radius: 16px;
        font-size: 0.8rem;
        font-weight: 600;
        display: inline-block;
        margin-right: 0.75em;

        &.active {
          background: rgba(76, 175, 80, 0.2);
          color: #81C784;
        }

        &.inactive {
          background: rgba(158, 158, 158, 0.2);
          color: #BDBDBD;
        }
      }

      .last--delivery {
        color: rgba(255, 255, 255, 0.5);
        font-size: 0.85rem;
        font-weight: normal;
      }

      .header--actions {
        display: flex;
        gap: 0.5em;
        flex-shrink: 0;
      }

      .btn--icon--close,
      .btn--icon--action {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        padding: 0.625em 1em;
        border-radius: 6px;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5em;
        font-weight: 600;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.15);
          color: #fff;
        }

        &.btn--danger {
          &:hover {
            background: rgba(244, 67, 54, 0.2);
            border-color: rgba(244, 67, 54, 0.4);
            color: #E57373;
          }
        }
      }
    }

    .webhook--form,
    .webhook--details--body {
      display: flex;
      flex-direction: column;
      gap: 1.5em;

      .form--group {
        label {
          display: block;
          color: rgba(255, 255, 255, 0.8);
          font-weight: 600;
          margin-bottom: 0.5em;
          font-size: 0.9rem;
        }

        input,
        textarea {
          width: 100%;
          padding: 0.875em 1em;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          color: #fff;
          font-size: 1rem;
          transition: all 0.3s ease;

          &::placeholder {
            color: rgba(255, 255, 255, 0.4);
          }

          &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.primary};
            background: rgba(255, 255, 255, 0.08);
          }
        }

        small {
          display: block;
          color: rgba(255, 255, 255, 0.5);
          margin-top: 0.5em;
          font-size: 0.85rem;
        }
      }

      .events--grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.75em;

        @media (max-width: 768px) {
          grid-template-columns: 1fr;
        }

        .event--checkbox--item {
          display: flex;
          align-items: center;
          gap: 0.75em;
          padding: 0.875em 1em;
          background: rgba(255, 255, 255, 0.03);
          border: 2px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.05);
            border-color: rgba(254, 125, 17, 0.3);
          }

          &.checked {
            background: rgba(254, 125, 17, 0.1);
            border-color: ${({ theme }) => theme.primary};

            .checkbox--icon {
              background: ${({ theme }) => theme.primary};
              color: #fff;
            }
          }

          .checkbox--icon {
            width: 20px;
            height: 20px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            font-size: 0.75rem;
            transition: all 0.2s ease;
          }

          .event--label {
            color: #fff;
            font-size: 0.9rem;
            font-weight: 500;
          }
        }
      }

      .detail--row {
        display: flex;
        flex-direction: column;
        gap: 0.5em;

        label {
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.85rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .detail--value,
        .detail--value--with--actions {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.875em 1em;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 6px;
          gap: 1em;

          code {
            color: #fff;
            font-family: 'Courier New', monospace;
            font-size: 0.9rem;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .value--actions {
            display: flex;
            gap: 0.5em;
            flex-shrink: 0;
          }

          .btn--icon--small {
            background: rgba(255, 255, 255, 0.1);
            border: none;
            padding: 0.5em;
            border-radius: 4px;
            color: rgba(255, 255, 255, 0.7);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.15);
              color: ${({ theme }) => theme.primary};
            }
          }

          .status--text {
            color: #fff;
            font-weight: 600;

            &.active {
              color: #81C784;
            }

            &.inactive {
              color: #BDBDBD;
            }
          }
        }

        .manage--events--btn {
          padding: 0.625em 1.25em;
          background: rgba(254, 125, 17, 0.15);
          border: 1px solid rgba(254, 125, 17, 0.3);
          border-radius: 6px;
          color: ${({ theme }) => theme.primary};
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            background: rgba(254, 125, 17, 0.25);
          }
        }
      }

      .events--subscribed--grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.75em;

        @media (max-width: 768px) {
          grid-template-columns: 1fr;
        }

        .event--badge--item {
          display: flex;
          align-items: center;
          gap: 0.5em;
          padding: 0.65em 1em;
          background: rgba(76, 175, 80, 0.15);
          border: 1px solid rgba(76, 175, 80, 0.3);
          border-radius: 6px;
          color: #81C784;
          font-size: 0.85rem;
          font-weight: 600;
        }
      }

      .form--actions {
        display: flex;
        gap: 1em;
        justify-content: flex-end;
        padding-top: 1em;
        border-top: 2px solid rgba(255, 255, 255, 0.1);

        @media (max-width: 768px) {
          flex-direction: column-reverse;

          .btn {
            width: 100%;
          }
        }
      }
    }

    .webhook--info--box {
      display: flex;
      gap: 1em;
      padding: 1.5em;
      background: rgba(33, 150, 243, 0.1);
      border: 1px solid rgba(33, 150, 243, 0.3);
      border-radius: 8px;
      margin-top: 2em;

      .info--icon {
        font-size: 1.5rem;
        flex-shrink: 0;
      }

      strong {
        display: block;
        color: #fff;
        margin-bottom: 0.5em;
      }

      p {
        color: rgba(255, 255, 255, 0.8);
        margin: 0;
        line-height: 1.6;
        font-size: 0.9rem;

        a {
          color: ${({ theme }) => theme.primary};
          text-decoration: underline;

          &:hover {
            color: #fff;
          }
        }
      }
    }
  }

  /* Legacy Webhook Styles - Keep for backwards compatibility */
  .webhook--form--container {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 2em;
    margin-bottom: 2em;

    @media (max-width: 768px) {
      padding: 1.5em;
    }

    .webhook--form--header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.5em;

      h3 {
        color: #fff;
        font-size: 1.25rem;
        margin: 0;
      }

      .btn--icon--close {
        background: rgba(255, 255, 255, 0.1);
        border: none;
        padding: 0.5em;
        border-radius: 4px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.15);
          color: ${({ theme }) => theme.primary};
        }
      }
    }

    .form--actions {
      display: flex;
      gap: 1em;
      justify-content: flex-end;
      margin-top: 1.5em;

      @media (max-width: 768px) {
        flex-direction: column-reverse;

        .btn {
          width: 100%;
        }
      }
    }
  }

  .events--list {
    display: grid;
    gap: 0.75em;
    margin-top: 0.75em;

    .event--item {
      display: flex;
      gap: 1em;
      padding: 1em;
      background: rgba(255, 255, 255, 0.03);
      border: 2px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(254, 125, 17, 0.3);
      }

      &.selected {
        background: rgba(254, 125, 17, 0.1);
        border-color: ${({ theme }) => theme.primary};

        .event--checkbox {
          background: ${({ theme }) => theme.primary};
          border-color: ${({ theme }) => theme.primary};
          color: #fff;
        }
      }

      .event--checkbox {
        width: 24px;
        height: 24px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: all 0.2s ease;
        font-size: 0.8rem;
      }

      .event--info {
        flex: 1;

        strong {
          display: block;
          color: #fff;
          font-size: 0.95rem;
          margin-bottom: 0.25em;
        }

        p {
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.85rem;
          margin: 0;
        }
      }
    }
  }

  .webhooks--list {
    display: flex;
    flex-direction: column;
    gap: 1em;

    .webhook--item {
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      padding: 1.5em;
      display: flex;
      align-items: flex-start;
      gap: 1em;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(254, 125, 17, 0.3);
      }

      @media (max-width: 768px) {
        flex-direction: column;
        padding: 1em;
      }

      .webhook--icon {
        width: 48px;
        height: 48px;
        background: rgba(254, 125, 17, 0.2);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({ theme }) => theme.primary};
        font-size: 1.5rem;
        flex-shrink: 0;

        @media (max-width: 768px) {
          width: 40px;
          height: 40px;
          font-size: 1.25rem;
        }
      }

      .webhook--info {
        flex: 1;
        min-width: 0;

        .webhook--header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.5em;
          flex-wrap: wrap;
          gap: 0.5em;

          strong {
            color: #fff;
            font-size: 1.1rem;

            @media (max-width: 768px) {
              font-size: 1rem;
            }
          }

          .webhook--status {
            padding: 0.25em 0.75em;
            border-radius: 12px;
            font-size: 0.75rem;
            font-weight: 600;

            &.active {
              background: rgba(76, 175, 80, 0.2);
              color: #81C784;
            }

            &.inactive {
              background: rgba(158, 158, 158, 0.2);
              color: #BDBDBD;
            }
          }
        }

        .webhook--url {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.9rem;
          font-family: 'Courier New', monospace;
          margin-bottom: 0.5em;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          @media (max-width: 768px) {
            font-size: 0.8rem;
          }
        }

        .webhook--meta {
          display: flex;
          gap: 1em;
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.5);
          flex-wrap: wrap;

          @media (max-width: 768px) {
            font-size: 0.75rem;
          }
        }
      }

      .webhook--actions {
        display: flex;
        gap: 0.5em;
        flex-shrink: 0;

        @media (max-width: 768px) {
          width: 100%;
          justify-content: flex-end;
        }

        .btn--icon {
          background: rgba(255, 255, 255, 0.1);
          border: none;
          padding: 0.625em;
          border-radius: 4px;
          color: rgba(255, 255, 255, 0.7);
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.95rem;

          &:hover {
            background: rgba(255, 255, 255, 0.15);
            color: ${({ theme }) => theme.primary};
          }

          &.btn--icon--danger:hover {
            background: rgba(244, 67, 54, 0.2);
            color: #E57373;
          }
        }
      }
    }
  }

  .webhook--details {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 2em;

    @media (max-width: 768px) {
      padding: 1.5em;
    }

    .webhook--details--header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 2em;
      gap: 1em;

      @media (max-width: 768px) {
        flex-direction: column;
      }

      h3 {
        color: #fff;
        font-size: 1.5rem;
        margin: 0 0 0.5em 0;

        @media (max-width: 768px) {
          font-size: 1.25rem;
        }
      }

      > div:last-child {
        display: flex;
        gap: 0.5em;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          width: 100%;

          .btn {
            flex: 1;
          }
        }
      }
    }

    .webhook--details--content {
      display: flex;
      flex-direction: column;
      gap: 1.5em;
      margin-bottom: 2em;

      .detail--group {
        label {
          display: block;
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 0.5em;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .detail--value {
          color: #fff;
          font-size: 1rem;
          padding: 0.75em 1em;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0.5em;

          @media (max-width: 768px) {
            font-size: 0.9rem;
          }
        }
      }

      .events--subscribed {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5em;

        .event--badge {
          display: flex;
          align-items: center;
          gap: 0.5em;
          padding: 0.5em 1em;
          background: rgba(76, 175, 80, 0.15);
          border: 1px solid rgba(76, 175, 80, 0.3);
          border-radius: 6px;
          color: #81C784;
          font-size: 0.85rem;
          font-weight: 600;

          @media (max-width: 768px) {
            font-size: 0.8rem;
            padding: 0.4em 0.8em;
          }
        }
      }
    }

    .webhook--actions--section {
      display: flex;
      gap: 1em;
      padding-bottom: 2em;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      @media (max-width: 768px) {
        flex-direction: column;

        .btn {
          width: 100%;
        }
      }
    }

    .info--box {
      display: flex;
      gap: 1em;
      padding: 1.5em;
      background: rgba(33, 150, 243, 0.1);
      border: 1px solid rgba(33, 150, 243, 0.3);
      border-radius: 8px;
      margin-top: 2em;

      @media (max-width: 768px) {
        padding: 1em;
      }

      .info--icon {
        font-size: 1.5rem;
        flex-shrink: 0;
      }

      strong {
        display: block;
        color: #fff;
        margin-bottom: 0.5em;
      }

      p {
        color: rgba(255, 255, 255, 0.8);
        margin: 0;
        line-height: 1.6;
        font-size: 0.9rem;

        a {
          color: ${({ theme }) => theme.primary};
          text-decoration: underline;

          &:hover {
            color: #fff;
          }
        }
      }
    }
  }

  .btn--secondary {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #fff;

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .btn--danger {
    background: rgba(244, 67, 54, 0.2);
    border: 1px solid rgba(244, 67, 54, 0.4);
    color: #E57373;

    &:hover:not(:disabled) {
      background: rgba(244, 67, 54, 0.3);
    }
  }
`;